import { formatNumber } from 'libphonenumber-js'


export const PhoneNumberFormat = {
  NATIONAL: "National",
  INTERNATIONAL: "International",
  E164: "E.164",
}

// Prettified to International Format like +44 20 8366 1177
export function prettifiedPhoneNumber(number, countryAlpha2=null) {
  let value = number;
  if (countryAlpha2) value = {country: countryAlpha2, phone: number };
  return formatNumber(value, PhoneNumberFormat.INTERNATIONAL)
}

// Normalize to E164 like +442083661177
export function normalizePhoneNumber(number, countryAlpha2=null) {
  let value = number;
  if (countryAlpha2) value = {country: countryAlpha2, phone: number };
  return formatNumber(value, PhoneNumberFormat.E164)
}

